import { create } from 'zustand';

export const useReceiptPartialStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openReceiptPartialStore: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null };
  }),
}));
export const openReceiptPartialStore = (payload) => {
  const store = useReceiptPartialStore.getState();
  store.openReceiptPartialStore(payload);
};

export const closeReceiptPartialStore = () => {
  const store = useReceiptPartialStore.getState();
  store.close();
};